import { Injectable, inject } from '@angular/core';
import { type ActivatedRouteSnapshot, type RouterStateSnapshot } from '@angular/router';
import { ENVIRONMENT_SETTINGS } from '@reconcept-platform/env';

@Injectable({
  providedIn: 'root',
})
export class RedirectToLoginGuard {
  private environmentSettings = inject(ENVIRONMENT_SETTINGS);

  // for backwards compatibility, redirect the requested url to the auth app
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): false {
    window.location.href = `${this.environmentSettings.authAppURL}${state.url}`;
    return false;
  }
}
